import Carrier from "../Carrier";

export const carrierDefaultValues: Carrier = {
  Id: 0,
  Gsdb: "",
  Name: "",
  CarrierManager: "",

  Street: "",
  City: "",
  Zip: "",

  CountryId: 0,
};
